export default __webpack_public_path__ + "static/rovo-overlay-remix2-light-98532552352033f8525a4e964768f2b6c443b98aa96d10ee0b4221729ca2460a.png";